import { createAsyncThunk } from "@reduxjs/toolkit";
import userApi from "../../Common/Api/UserApi"
import Cookies from "universal-cookie";
import jwt_decode from "jwt-decode";
import Cookies2 from 'js-cookie';
import api from "../../Common/Api/UserApi";

const cookies = new Cookies();

export const Usersignup = createAsyncThunk("auth/signup", async ({ name, email, password, contact }, { rejectWithValue }) => {
    try {
        // make request to backend
        console.log("Req come for : ", name, email, password, contact);
        const { data } = await userApi.post('/user/signup', { name, email, password, contact })
        return data;

    } catch (error) {
        // return custom error message from API if any
        if (error.response && error.response.data.message) {
            return rejectWithValue(error.response.data.message)
        } else {
            return rejectWithValue(error.message)
        }
    }
})
export const Userlogin = createAsyncThunk("auth/login", async ({ email, password }, { rejectWithValue }) => {
    try {
        // make request to backend
        console.log("Req come for : ", email, password,);
        const { data } = await userApi.post('/user/login', { email, password })
        console.log(data)
        const decodedToken = jwt_decode(data.token)
        cookies.set("token", data.token, {
            expires: new Date(decodedToken.exp * 1000)
        })
        return data;

    } catch (error) {
        // return custom error message from API if any
        if (error.response && error.response.data.message) {
            return rejectWithValue(error.response.data.message)
        } else {
            return rejectWithValue(error.message)
        }
    }
})

export const fetchuserAds = createAsyncThunk("user/fetchUserAds", async ({ userId }, { rejectWithValue }) => {
    try {
        // console.log(cookies.get('token'));
        const user = { _id: userId }
        const { data } = await userApi.get('/user/ads', user);

        return data;
    } catch (error) {
        // return custom error message from API if any
        if (error.response && error.response.data.message) {
            return rejectWithValue(error.response.data.message)
        } else {
            return rejectWithValue(error.message)
        }
    }
})
export const handleAcceptAd = createAsyncThunk("user/handleAcceptAd", async ({ adId }, { rejectWithValue }) => {
    try {
        const { data } = await userApi.get(`/user/ads/${adId}/approve-ad`, {
            headers: {
                'Authorization': `Bearer ${cookies.get('token')}`,
            }
        });
        console.log(data);
        return data;
    } catch (error) {
        // return custom error message from API if any
        if (error.response && error.response.data.message) {
            return rejectWithValue(error.response.data.message)
        } else {
            return rejectWithValue(error.message)
        }
    }
})
export const handleRejectAd = createAsyncThunk("user/handleRejectAd", async ({ adId }, { rejectWithValue }) => {
    try {
        const { data } = await userApi.get(`/user/ads/${adId}/reject-ad`, {
            headers: {
                'Authorization': `Bearer ${cookies.get('token')}`,
            }
        });
        console.log(data);
        return data;
    } catch (error) {
        // return custom error message from API if any
        if (error.response && error.response.data.message) {
            return rejectWithValue(error.response.data.message)
        } else {
            return rejectWithValue(error.message)
        }
    }
})

export const fetchCartItems = createAsyncThunk('user/fetchCartItems', async ({ userId }, { rejectWithValue }) => {

    try {

        const { data } = await userApi.get('/user/cart', {
            user: {
                _id: userId
            }
        }, {
            headers: {
                'Authorization': `Bearer ${cookies.get('token')}`,
            }
        })
        console.log(data);
        return data;

    } catch (error) {
        rejectWithValue(error)
    }

})
export const UserEdit = createAsyncThunk("User/edit", async ({ user, address }, { rejectWithValue }) => {
    try {
        console.log(user, address)

        const { streetAddress, state, city, pincode } = address;
        const { name, id, contact, location } = user;

        // name, contact, shippingAddress, location
        console.log("Req come for : ", user, name, contact, streetAddress, location)
        const { data } = await userApi.post('/user/edit', { user: { _id: id }, name, contact, location, shippingAddress: { streetAddress, state, city, pincode } }, {
            headers: {
                'Authorization': `Bearer ${Cookies2.get('token')}`,
            },
        })
        console.log(data)
        return data;
    } catch (error) {
        if (error.response && error.response.data.message) {
            return rejectWithValue(error.response.data.message)
        } else {
            return rejectWithValue(error.message)
        }
    }
})
